export enum EventBusEventEnum {
  CreateNotification = 'createNotification',
  RightPanelOpen = 'rightPanelOpen',
  RightPanelClose = 'rightPanelClose',
  UnauthorizedRequest = 'unauthorizedRequest',
  OnLogout = 'onLogout',
  FirstApiRequest = 'firstApiRequest',
  MakeLogout = 'makeLogout',
  IsGlobalLoaderVisible = 'isGlobalLoaderVisible',
  OnFilesFiltersChange = 'onFilesFiltersChange',
  OnShareFiles = 'onShareFiles',
  CreateUser = 'createUser',
  CreateGroup = 'createGroup',
  RefreshGroupDetail = 'refreshGroupDetail',
  CreateFolder = 'createFolder',
  CreateOfficeDocument = 'createOfficeDocument',
  CreateFileFromTemplate = 'createFileFromTemplate',
  OnFilesUpdated = 'onFilesUpdated',
  OnFilesDeleted = 'onFilesDeleted',
  OnUsersUpdated = 'onUsersUpdated',
  OnUsersDeleted = 'onUsersDeleted',
  OnGroupsUpdated = 'onGroupsUpdated',
  OnGroupsDeleted = 'onGroupsDeleted',
  IsUploadDisabledInCurrentFolder = 'isUploadDisabledInCurrentFolder',
}
